<app-template-datetime [disabled]="disabled" [value]="value" [control]="control" [required]="required" [label]="label" [characters]="characters" />
